import { render } from "./EmployeeLocationWidget.vue?vue&type=template&id=6feb8008&scoped=true"
import script from "./EmployeeLocationWidget.vue?vue&type=script&lang=js"
export * from "./EmployeeLocationWidget.vue?vue&type=script&lang=js"

import "./EmployeeLocationWidget.vue?vue&type=style&index=0&id=6feb8008&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6feb8008"]])

export default __exports__